import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { AuthState } from './auth';
import { HexabaseState } from './hexabase';
import { UserState } from './user';
import { SearchState } from './search';
import { AppState } from './app';

Vue.use(Vuex);

export interface RootState {
  auth: AuthState;
  user: UserState;
  hexabase: HexabaseState;
  search: SearchState;
  app: AppState;
}

export default new Vuex.Store<RootState>({
  plugins: [
    createPersistedState({
      key: 'sample-ui',
      paths: ['auth', 'user', 'hexabase', 'search', 'app'],
      storage: window.sessionStorage
    })
  ]
});
